<template>
  <div id="app">
    <router-view />
<!--    <KuangJia/>-->
  </div>
</template>

<script>
import KuangJia from "@/views/KuangJia.vue";

export default {
  name: "Login",
  components:{KuangJia},
  data() {
    return {
      login:'0',
    }
  },
  mounted() {


  }
}
</script>

<style>
</style>
